import { PRODUCT_LINES } from '../../constants/auto'

export function getAutoPrice(auto) {
  switch (auto.linea_prodotto) {
    case PRODUCT_LINES.NLT_BRUMBRUM:
      return (
        (auto.canone_anticipo_zero || auto.canone_mensile) +
        auto.cap_variabile_kilometrico
      )

    case PRODUCT_LINES.NLT_ARVAL:
      return auto.canone_anticipo_zero || auto.canone_mensile

    default:
      return auto.prezzo_scontato || auto.prezzo_sellout
  }
}

export function getOrderPrice(productLine, orderState, nltState) {
  switch (productLine) {
    case PRODUCT_LINES.NLT_BRUMBRUM:
      return (
        nltState?.selectedCanone?.canone_mensile +
        nltState?.selectedCanone?.cap_variabile_kilometrico
      )

    case PRODUCT_LINES.NLT_ARVAL:
      return (
        nltState?.selectedCanone?.canone_mensile + nltState?.serviziPlusCosto
      )

    default:
      return orderState.totale
  }
}
